import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Banner from "./components/Banner/Banner";
import HomePage from "./components/Pages/HomePage";
import { Toaster } from "react-hot-toast";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="layout">
      <Toaster />
      <BrowserRouter>
        <Banner />
        <div className="content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* <Route path="/socials" element={<SocialsPage />} /> */}
            {/* <Route path="/music" element={<Music />} /> */}
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
